import { BaseComponent2 } from '../../_common/client/base-component2';
import { addMoveTrackingToAllReviewsButton } from './helper/add-move-tracking-to-all-reviews-button';
import { scrollToReviewsIfStarFilterIsSet } from './helper/scroll-to-reviews-if-star-filter-is-set';
import { registerOnSortSelectionChange } from './helper/register-on-sort-selection-change';
import { registerOnFilterEvent } from './helper/register-on-filter-event';
import { initializePagination } from './helper/pagination/initialize-pagination';
import { trackReviewCountOnPageImpression } from './helper/track-review-count-on-page-impression';
import { trackReviewImageCountOnPageImpression } from './helper/track-review-image-count-on-page-impression';
import { scrollToReviewsIfHashParamIsSet } from './helper/scroll-to-reviews-if-hash-param-is-set';

export class CustomerReviewListWrapperComponent extends BaseComponent2 {
    public rootSelector = '.js_cr_list-wrapper';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        const rootElement = this.getRootElement();
        if (rootElement.hasAttribute('data-review-summary-list')) return;
        addMoveTrackingToAllReviewsButton(rootElement);
        scrollToReviewsIfStarFilterIsSet(rootElement);
        await scrollToReviewsIfHashParamIsSet(rootElement);
        initializePagination(rootElement);
        registerOnFilterEvent(rootElement);
        registerOnSortSelectionChange(rootElement);
        trackReviewCountOnPageImpression(rootElement);
        trackReviewImageCountOnPageImpression(rootElement);
    }
}
